import { render } from "./pidSearch.vue?vue&type=template&id=513a4ded"
import script from "./pidSearch.vue?vue&type=script&lang=js"
export * from "./pidSearch.vue?vue&type=script&lang=js"

import "./pidSearch.vue?vue&type=style&index=0&id=513a4ded&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__